import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminPageUrl, DiagnosisPageUrl, StuffPageUrl } from '../url/poenUrl';

const PermissionRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const permissions = localStorage.getItem('permissions');
    const accessToken = localStorage.getItem('accessToken');

    if (permissions && accessToken) {
      switch (permissions) {
        case 'ADMIN':
          navigate(AdminPageUrl); // ADMIN 사용자 -> AdminPage로 이동
          break;
        case 'SELLER':
          navigate(DiagnosisPageUrl); // SELLER 사용자 -> DiagnosisPage로 이동
          break;
        default:
          navigate(StuffPageUrl); // 기타 사용자 -> StuffPage로 이동
          break;
      }
    }
  }, [navigate]);

  return null; // 이 컴포넌트는 UI를 렌더링하지 않음
};

export default PermissionRedirect;
